/*=========================================================================================
	File Name: state.js
	Description: Vuex Store - state
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, { colors } from '@/../themeConfig.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
	uid: 0,          // From Auth
	displayName: 'John Doe', // From Auth
	about: 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
	photoURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAABACAMAAABvC9RJAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAdpQTFRFAAAAWih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/Wih/xIT4tQAAAJ50Uk5TAAEGCX5En/9oi4RK/aEr6rcLxdR38AAs/ggH2SMDTrrlXQKXPWLcxjUFF5X8NyAuwaMeFHbN6IUkJoriYxnJ4WDk+dX4iASw9fdpyOwnVr+Yjt2dgs6Z8pE+veublPH7qOCvnMc/vrXRyq36pTnYepBLUH3zj7PpSMyyy7iGwpO8eaeJ9nWW014Q5li721Tf2nLtXPSSO8Mpe0nAWiKiZV2qAAACM0lEQVR4nGNgGGKAkYlUHcwsrKTawcbOQaotnOxcpGrh5uElVQsfvwCpWgSFhEnVwiAiKkaqFnEJSRJUS4FJaRkQycRIWL2snLyCohKQoawC9JGqmrqGJgEdWto67Ozs6rpKDHqMjPoGQDaPoRE+XxmbmIJ0sLObmVuIWVpZg9kSwja2uLXYSbBDgYS9gyOMze7kjNtxLuwI4IrEZscdeiNai5ueuwdMjaeQl7cOjOMj74s9Nt38/AMCgyCKPIJDQrnCwiEcBdcI9UgspYeYRhQwHqNjYuPY2eMTuNSAShNdk+KBQskgIfaUVPQEqp8G9Yeja0Q6SwY0FWSyZIXBLM7OyUXRoZuN8GpePpK/CwwQbIlCZC1FSKpcApA47olIHI5RLXCggciCHinFJXBOeGkZPNlIlFegRIxvMiSjx1dqV1VHyMdBdAuUqtfECkHizKxWHy2hyerXgRTVBwNVuzSYgGyNbowCqvZpam4BckJ1lRgwgGBrUBVXJsQR0aVtPtpWUNe21zY5dnRiagDblILwale3GZzN4yyFXQPDoM3Ig1hLD0JRb18/nJ2d6YZTi1jjBEiuj0tu9ZloOAmiw34yloiHA0aLCKC6KfJT7eLZs1PqozyBcZrMR6Dyc5umPT0wbQrYeM8GzjTeGUS0f5RmtsB90RKI2xfIACWLEaVjpGspRtKiTZwWhlkpPGD1ErNZiWj1QICsnDNQR94cQi0eFNAZaM+FLzFiA0pzSdUx8AAAXfyE05YZLgkAAAAASUVORK5CYII=", // From Auth
	status: 'online',
	userRole: 'admin'
}

const userInfoLocalStorage = localStorage.getItem('userInfoAuth') == "" ? "" : localStorage.getItem('userInfoAuth') || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {

	const userInfo = {}
	let userInfoLocalStorage2 = []
	console.log(userInfoLocalStorage)
	if (userInfoLocalStorage != "") {
		if (userInfoLocalStorage.toString().includes('[object Object]')) { }
		else
			userInfoLocalStorage2 = JSON.parse(userInfoLocalStorage)
		// Update property in user
		Object.keys(userDefaults).forEach((key) => {
			// If property is defined in localStorage => Use that
			userInfo[key] = userInfoLocalStorage2[key] ? userInfoLocalStorage2[key] : userDefaults[key]
		})

		// Include properties from localStorage
		Object.keys(userInfoLocalStorage2).forEach((key) => {
			if (userInfo[key] === undefined && userInfoLocalStorage2[key] !== null) userInfo[key] = userInfoLocalStorage2[key]
		})
	}

	return userInfo
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
	const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
	const mq = function (query) {
		return window.matchMedia(query).matches
	}

	if ('ontouchstart' in window || window.DocumentTouch) {
		return true
	}

	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
	return mq(query)
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
	AppActiveUser: getUserInfo(),
	bodyOverlay: false,
	isVerticalNavMenuActive: true,
	is_touch_device: is_touch_device(),
	mainLayoutType: themeConfig.mainLayoutType || 'horizontal',
	navbarSearchAndPinList,
	reduceButton: themeConfig.sidebarCollapsed,
	verticalNavMenuWidth: 'default',
	verticalNavMenuItemsMin: false,
	scrollY: 0,
	starredPages: navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
	theme: themeConfig.theme || 'light',
	themePrimaryColor: colors.primary,

	// Can be used to get current window with
	// Note: Above breakpoint state is for internal use of sidebar & navbar component
	windowWidth: 1200
}

export default state
